import { useState, useMemo } from "react"
import { Button, Avatar, Chip, Tab } from "@mui/material"
import { FiberManualRecord, MarkEmailUnread } from "@mui/icons-material"
import { invitationResponseStatus } from "../../../../../app/store/constant"
import { H6, Body2, Body3, Body1 } from "../../../../../themes/typography"

export default function InvitationOverview({
    data = [],
    onViewAllInvitations = () => { }
}) {

    const [activeTab, setActiveTab] = useState(0);

    // 🔍 Define tab options for easier control
    const tabs = [
        { label: "Pending", value: invitationResponseStatus.pending },
        { label: "Confirmed", value: invitationResponseStatus.confirmed },
        { label: "Rejected", value: invitationResponseStatus.rejected }
    ];

    // 🧮 Filter data based on active tab
    const filteredData = useMemo(() => {
        const selected = tabs[activeTab]?.value;
        return data.filter((item) => item?.response?.toLowerCase() === selected);
    }, [data, activeTab]);

    return (
        <div className="event-dashboard-invitation-overview">
            <div className="event-dashboard-invitation-overview-wrapper">

                <div className="invitation-overview-content">
                    <div className="invitation-overview-header">
                        <div className="invitation-overview-title">
                            <H6 fontWeight={600}>Invitation</H6>
                        </div>

                        <div className="invitation-overview-statistics">

                            <InvitationStat label="Total" count={data.length} />

                            <FiberManualRecord color="white" sx={{ fontSize: '0.5rem' }} />
                            <InvitationStat
                                label="Pending"
                                count={data.filter((i) => i.response?.toLowerCase() === invitationResponseStatus.pending).length}
                            />

                            <FiberManualRecord color="white" sx={{ fontSize: '0.5rem' }} />
                            <InvitationStat
                                label="Confirmed"
                                count={data.filter((i) => i.response?.toLowerCase() === invitationResponseStatus.confirmed).length}
                            />

                            <FiberManualRecord color="white" sx={{ fontSize: '0.5rem' }} />
                            <InvitationStat
                                label="Rejected"
                                count={data.filter((i) => i.response?.toLowerCase() === invitationResponseStatus.rejected).length}
                            />
                        </div>
                    </div>

                    <div className="invitation-stats-tabs">
                        {tabs.map((tab, index) => (
                            <Tab
                                key={index}
                                label={tab.label}
                                onClick={() => setActiveTab(index)}
                                sx={{
                                    minWidth: 'auto',
                                    maxWidth: '100px',
                                    minHeight: 'auto',
                                    textTransform: 'none',
                                    color: activeTab === index ? 'var(--tertiary-color)' : 'var(--quaternary-color)',
                                    border: activeTab === index ? '1px solid var(--tertiary-color)' : '2px solid transparent',
                                    transition: '0.2s ease',
                                }}
                            />
                        ))}
                    </div>

                    <div className="invitation-overview-list">
                        {filteredData.length === 0 ? (
                            <div className="no-system-alerts">
                                <div className="no-system-alerts-icon">
                                    <MarkEmailUnread sx={{ fontSize: "3rem" }} color="inherit" />
                                </div>
                                <Body1 fontWeight={400}>
                                    No invitations found.
                                </Body1>
                                <Body2 color="var(--secondary-color)" fontWeight={350}>
                                    {activeTab === 0 && " When you send invitations, their details will appear here."}
                                    {activeTab === 1 && " You currently have no confirmed invitations."}
                                    {activeTab === 2 && " You currently have no rejected invitations."}
                                </Body2>
                            </div>
                        ) : (
                            filteredData.slice(0, 6).map((invitation, index) => (
                                <EachInvitationDetails
                                    key={index}
                                    invitation={invitation}
                                />
                            ))
                        )}
                    </div>
                </div>


                <div className="view-all-invitations">
                    <Button
                        variant="lightToggleActiveSm"
                        fullWidth={true}
                        onClick={onViewAllInvitations}
                    >
                        Manage Invitations
                    </Button>
                </div>
            </div>
        </div>
    )
}

function InvitationStat({ label, count }) {
    return (
        <div className="each-invitation-stats">
            <Body3>{label}</Body3>
            <div className="each-invitation-stats-number">
                <Body3 fontWeight={500}>{count}</Body3>
            </div>
        </div>
    );
}

function EachInvitationDetails({ invitation }) {
    return (
        <div className="each-invitation-detail">
            <div className="each-invitation-detail-wrapper">

                <div className="invitation-detail-left">
                    <Avatar sx={{ width: 38, height: 38 }}>
                        {invitation?.name?.charAt(0)?.toUpperCase()}
                    </Avatar>
                    <div className="invitation-detail-info">
                        <Body2 fontWeight={500}>
                            {invitation?.name}
                        </Body2>
                        {/* <Body3>
                            VIP Ticket
                        </Body3> */}
                    </div>
                </div>

                {invitation?.response === invitationResponseStatus.pending && (
                    <div className="invitation-detail-right">
                        <Chip label="Pending" color="warningSm" />
                    </div>
                )}

                {invitation?.response === invitationResponseStatus.confirmed && (
                    <div className="invitation-detail-right">
                        <Chip label="Confirmed" color="successSm" />
                    </div>
                )}

                {invitation?.response === invitationResponseStatus.rejected && (
                    <div className="invitation-detail-right">
                        <Chip label="Rejected" color="errorSm" />
                    </div>
                )}
            </div>
        </div>
    )
}